<template>
    <div class="LeadingTalentwarp">
        <NavMenu :tokenText="tokenText" />
        <img :src="img1" alt="" class="topimgbox" @click="singupFn">
        <div class="witebox"></div>
        <Footer/>
    
        <!-- 预审 -->
        <!-- <div v-if="singupVisible"> -->
        <LeadGooseSingupModal v-if="step==1" @changeShowFirst='changeShowFirst' />
        <!-- 注册 -->
        <LeadGooseRegistModal v-if="step==2" :firstFormData='firstFormData' @changeShowRegist='changeShowRegist' />
        <!-- 第二步 -->
        <LeadGooseSecondModal v-if="step==3" :leartrainData='leartrainData' @changeShowSecond='changeShowSecond' />
        <!-- 上传文件 -->
        <LeadGooseFileModal v-if="step==4" @changeShowFile='changeShowFile' />
        <!-- 开票信息 -->
        <LeadGooseBillModal v-if="step==5" @changeShowBill='changeShowBill' :leartrainData='leartrainData' />

    </div>
</template>
<script>
import NavMenu from '@/components/navMenu.vue'
import Footer from '@/components/footer.vue'
import LeadGooseSingupModal from './LeadGooseSingupModal'
import LeadGooseRegistModal from './LeadGooseRegistModal'
import LeadGooseSecondModal from './LeadGooseSecondModal'
import LeadGooseFileModal from './LeadGooseFileModal'
import LeadGooseBillModal from './LeadGooseBillModal'
import { httpService, srcUrl, videoUrl } from "@/service/httpService";
// import { nextTick } from 'q';
export default {
    components: {
        NavMenu,
        Footer,
      
        LeadGooseSingupModal,
        LeadGooseRegistModal,
        LeadGooseSecondModal,
        LeadGooseFileModal,
        LeadGooseBillModal
    },
    data() {
        return {
            srcUrl: srcUrl,
            img1: require("@/assets/imgs/lead/img1.png"),
            img2: require("@/assets/imgs/lead/img2.png"),
            dataList: [],
            workcurrentPage: 1,
            workpageSize: 5,
            worktotal: null,
            step: 0,            // singupVisible: false,
            // 注册
            registVisible: false,
            // 完善資料
            secondVisible: false,
            studentIndex: -1,
            studentData: [],
            studentcurrentPage: 1,
            studentpageSize: 3,
            studenttotal: null,
            islogin: sessionStorage.getItem('token'),
            leartrainData: null,
            // 弹框
            fileVisible: false,
            status: '',//报名状态
            leadNewsObj: null,
            newsVisible: false,
            // 证书查询
            infoVisible: false,
            dialogList: [
                { name: '报名信息' },
                { name: '成绩证书' },
            ],
            dialogcurrentSearch: '成绩证书',
            currentPage: 1,
            pageSize: 10,
            total: null,
            ruleForm: {
                names: '',
                cardCode: '',
            },
            inforules: {
                names: [
                    { required: true, message: '姓名', trigger: 'blur' },
                ],
                cardCode: [
                    { required: true, message: '请输入正确的身份证号码', pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, trigger: 'blur' }
                ],
            },
            infoDataList: [],
            leadTitle: '',
            firstFormData: null,
            firstShow: 0,
            source: null,
            tokenText: "",
        }
    },
    created() {
        // 获取头雁人才课程信息
        this.getleadInfo()
    },
    methods: {
        async getleadInfo() {
            httpService.getHeadGooesClass().then(res => {
                if (res.code == 200) {
                    this.leartrainData = res.result
                    this.status = res.result.status
                    if (this.source == 'account') {
                        this.singupFn()
                    }
                } else {
                    this.$message.error(res.message);
                }
            })
        },

        singupFn() {
            // this.getleadInfo()
            if (this.leartrainData) {
                let auditResultStatus = this.leartrainData.auditResultStatus
                if (!this.islogin) {
                    this.step = 1
                    this.stopScroll()
                } else {
                    if (auditResultStatus) {
                        switch (auditResultStatus) {
                            case '1':
                                // this.$message({
                                //     message: '预审报名审核中，审核结果请移至【账户中心】下的【消息通知】进行查看',
                                //     type: 'warning'
                                // });
                                this.step = 3
                                this.stopScroll()
                                break;
                            case '2':
                                if (this.leartrainData.billAudit == 1) {
                                    this.$message({
                                        message: '领军人才课程待缴费，报名信息请移至【账户中心】下的【培训课程管理】进行查看',
                                        type: 'warning'
                                    });
                                    return
                                } else {
                                    this.step = 5
                                }
                                this.stopScroll()
                                break;
                            case '3':
                                //  上传文件审核失败
                                // this.fileVisible = true
                                this.step = 4
                                this.stopScroll()
                                break;
                            case '4':
                                this.$message({
                                    message: '领军人才课程报名已完成，报名信息请移至【账户中心】下的【培训课程管理】进行查看',
                                    type: 'warning'
                                });
                                break;
                            case '5':
                                this.$message({
                                    message: '领军人才课程已生成班级，报名信息请移至【账户中心】下的【培训课程管理】进行查看',
                                    type: 'warning'
                                });
                                break;
                            case '6':
                                this.$message({
                                    message: '领军人才课程培训已完成，报名信息请移至【账户中心】下的【培训课程管理】进行查看',
                                    type: 'warning'
                                });
                                break;
                            case '0':
                                //  保存草稿
                                // this.secondVisible = true
                                this.step = 3
                                this.stopScroll()
                                break;
                            case '98':
                                //  填写详情信息
                                // this.secondVisible = true
                                this.step = 3
                                this.stopScroll()
                                break;
                            case '99':
                                this.$message({
                                    message: '信息审核中，审核结果请移至【账户中心】下的【消息通知】进行查看',
                                    type: 'warning'
                                });
                                break;
                            case '100':
                                //  上传文件
                                // this.fileVisible = true
                                this.step = 4
                                this.stopScroll()
                                break;
                            case '101':
                                if (this.leartrainData.billAudit == 1) {
                                    this.$message({
                                        message: '文件审核中，审核结果请移至【账户中心】下的【消息通知】进行查看',
                                        type: 'warning'
                                    });
                                    return
                                } else {
                                    this.step = 5
                                }
                                this.stopScroll()
                                break;
                            case '198':
                                // this.singupVisible = true
                                this.step = 1
                                this.stopScroll()
                                //  预审审核失败，重回第一步
                                break;
                            case '199':
                                // this.secondVisible = true
                                this.step = 3
                                this.stopScroll()
                                //  详细信息审核失败，重回第二步
                                break;
                            default:
                                break;
                        }
                    } else {
                        this.step = 1
                        this.stopScroll()
                    }
                }
            } else {
                this.getleadInfo()
            }
            // auditResultStatus 0、报存草稿1：提交 2：审核通过3：审核失败4.已缴费,
            // 5，加入班级，6成绩录入，98后台初审通过，99第二次提交，100第二次审核通过，101第三次提交，198初步审核失败，199第二步审核失败）
            // 判断是否能继续报名
            // if (!this.leartrainData.flag) {
            //     this.$message({
            //         message: '领军人才课程报名已完成，报名信息请移至【账户中心】下的【培训课程管理】进行查看',
            //         type: 'warning'
            //     });
            // }
            // else {

            // }
            // if (!this.islogin) {
            //     this.$message({
            //         message: '请先登录网站',
            //         type: 'warning'
            //     });
            // } else {
            // 1提交 2审核通过 3审核失败
            // 現在判断是否能继续报名的状态还没有返回，auditResult是错误的
            // if (this.leartrainData.flag) {
            //     this.singupVisible = true
            //     if (this.leartrainData.auditStatus == 2) {

            //     }
            // }
            //  else {
            //     this.$message({
            //         message: '您已报名成功，请等待审核，报名信息请移至【账户中心】下的【培训课程管理】进行查看',
            //         type: 'warning'
            //     });
            // }
            //  this.singupVisible = true
            // }
        },
       
        changeShowFirst(data, data1, data2) {
            // data1有用户，data2注册需要的数据
            if (data == '关闭') {
                this.step = 0
                this.canScroll()
            } else {
                // 用户已登录
                if (!data) {
                    this.step = 0
                    this.canScroll()
                    if (!data1) {
                        this.step = 2
                        this.stopScroll()
                    } else {
                        if (!this.islogin) {
                            httpService.loginFn(data2).then(res => {
                                if (res.code == 200) {
                                    let data = res.result
                                    sessionStorage.setItem('clickMenu', '培训服务')
                                    sessionStorage.setItem('token', data.token)
                                    sessionStorage.setItem('userInfo', JSON.stringify(data.principal.loginVo))
                                    this.islogin = data.token
                                    this.step = 3
                                    this.canScroll()
                                    this.tokenText = data.token
                                    // this.$nextTick(() => {
                                    //     // console.log('是否进入');
                                    //     // this.singupVisible = false
                                    //     this.$router.push('/leade-talent');
                                    //     this.$router.go(0)
                                    //     // 登录之后直接完善信息
                                    // })
                                } else {
                                    this.$message.error(res.message);
                                }
                            });
                        }
                        // 当用户登录之后提交第一步就可以再次提交第二步
                        else {
                            this.step = 3
                            this.stopScroll()
                        }
                    }
                }
            }
            if (data2) {
                this.firstFormData = data2
            }
            if (this.source == 'account') {
                this.$router.push({ query: {} });
                this.source = null
            }
            this.getleadInfo()
        },
        changeShowRegist(data, data2) {
            if (!data) {
                this.step = 0
                this.canScroll()
                if (data2) {
                    httpService.loginFn(data2).then(res => {
                        if (res.code == 200) {
                            let data = res.result
                            sessionStorage.setItem('clickMenu', '培训服务')
                            sessionStorage.setItem('token', data.token)
                            sessionStorage.setItem('userInfo', JSON.stringify(data.principal.loginVo))
                            this.islogin = data.token
                            this.step = 3
                            this.canScroll()
                            this.tokenText = data.token
                            this.$nextTick(() => {
                                // 用户未注册未登录 注册登录后直接进行第二步
                                // this.step = 0
                                // this.$router.push('/leade-talent');
                                // this.$router.go(0)
                            })
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                }
            }
            this.getleadInfo()
        },
        // 完善信息
        changeShowSecond(data) {
            if (!data) {
                this.step = 0
                this.canScroll()
            }
            if (this.source == 'account') {
                this.$router.push({ query: {} });
                this.source = null
            }
            this.getleadInfo()
        },
        // 上传文件
        changeShowFile(data) {
            if (!data) {
                this.step = 0
                this.canScroll()
            }
            if (this.source == 'account') {
                this.$router.push({ query: {} });
                this.source = null
            }
            this.getleadInfo()
        },
        // 开票信息
        changeShowBill(data) {
            if (!data) {
                this.step = 0
                this.canScroll()
            }
            if (this.source == 'account') {
                this.$router.push({ query: {} });
                this.source = null
            }
            this.getleadInfo()
        },
      

    },
    filters: {
        timer: (value) => {
            return value.substring(0, 10);
        },
        // day: (value) => {
        //     return value.substring(8, 10);
        // },
        timers: (value) => {
            return value.substring(0, 10);
        },
    },
}
</script>
<style lang="less" scoped>
.LeadingTalentwarp {
	width: 100%;
	margin: 0 auto;
	.topimgbox {
		width: 100%;
		// height: 405px;
		cursor: pointer;
	}
    .witebox{
        margin-bottom: 120px;
    }
}
.dialogWarp {
	/deep/.singupdialogcenter {
		padding: 17px 60px 0px 60px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		.textbox {
			text-align: left;
			font-size: 16px;
			line-height: 21px;
			color: #333333;
			cursor: pointer;
			span,
			.iconbox {
				color: #448df7;
				cursor: pointer;
			}
			.iconbox {
				margin-left: 4px;
			}
		}
		.submintBtn {
			width: 152px;
			height: 40px;
			background: #448df7;
			color: #fff;
			margin: 0 20px;
			cursor: pointer;
			font-size: 16px;
			text-align: center;
			line-height: 40px;
		}
	
		.singupForm {
			width: 100%;
			/deep/.el-upload--picture-card {
				width: 100px;
				height: 100px;
				line-height: 100px;
			}
			/deep/.el-form-item__label {
				padding: 0;
			}
			/deep/.el-form-item {
				margin-bottom: 10px;
			}
			/deep/.el-upload-list--picture-card .el-upload-list__item {
				width: 100px;
				height: 100px;
			}
			.formBtnBox {
				display: flex;
				fill-opacity: row;
				justify-content: center;
				.submitBtn {
					width: 152px;
					height: 40px;
					background: #349cff;
					margin: 0 20px;
				}

				.cancelBtn {
					width: 152px;
					height: 40px;
					border: 1px solid #a6a9b7;
					border-radius: 5px;
					margin: 0 20px;
				}
			}
			.upicon {
				font-size: 48px;
			}
			.videobox {
				width: 200px;
				height: 200px;
				display: flex;
				flex-direction: row;
				align-content: center;
				// position: relative;
				video {
					object-fit: fill;
				}
				.spanbox {
					// position: absolute;
					// top: 100px;
					// left: 50%;
					// transform: translateX(-50%);
					// width: 50px;
					// height: 50px;
					// text-align: center;
					// line-height: 50px;
					// border-radius: 50%;
					// background: rgb(238, 237, 237);
					margin-left: 10px;
					.videoicon {
						font-size: 20px;
						cursor: pointer;
					}
					&:hover {
						// background: rgb(179, 220, 247);
						color: #349cff;
					}
				}
			}
			.videoFormItem {
				/deep/.el-form-item__content {
					position: relative;
				}
				.videoText {
					position: absolute;
					top: -40px;
					left: 100px;
					cursor: pointer;
					font-size: 14px;
					color: #ff8916;
				}
			}
		}
	}
	.pagination-box {
		margin: 0;
	}
}
</style>


